export const conversionCategories = {
  length: {
    name: 'Länge',
    units: {
      'Pikometer (pm)': 0.000000000001,
      'Nanometer (nm)': 0.000000001,
      'Mikrometer (µm)': 0.000001,
      'Millimeter (mm)': 0.001,
      'Zentimeter (cm)': 0.01,
      'Dezimeter (dm)': 0.1,
      'Meter (m)': 1,
      'Dekameter (dam)': 10,
      'Hektometer (hm)': 100,
      'Kilometer (km)': 1000,
      'Zoll (in)': 0.0254,
      'Fuß (ft)': 0.3048,
      'Yard (yd)': 0.9144,
      'Meile (mi)': 1609.344,
      'Seemeile (NM)': 1852,
      'Astronomische Einheit (AE)': 149597870700,
      'Lichtminute (lm)': 17987547480,
      'Lichtsekunde (ls)': 299792458,
      'Lichtjahr (Lj)': 9460730472580800,
      'Parsec (pc)': 30856775814671900,
      'Kiloparsec (kpc)': 30856775814671900000,
      'Megaparsec (Mpc)': 30856775814671900000000,
      'Sonnendurchmesser (SD)': 1392700000,
      'Erdradius (ER)': 6371000
    }
  },
  weight: {
    name: 'Gewicht',
    units: {
      'Mikrogramm (µg)': 0.000000001,
      'Milligramm (mg)': 0.000001,
      'Zentigramm (cg)': 0.00001,
      'Dezigramm (dg)': 0.0001,
      'Gramm (g)': 0.001,
      'Dekagramm (dag)': 0.01,
      'Hektogramm (hg)': 0.1,
      'Kilogramm (kg)': 1,
      'Tonne (t)': 1000,
      'Pfund (lb)': 0.453592,
      'Unze (oz)': 0.0283495,
      'Karat (ct)': 0.0002,
      'Stone (st)': 6.35029,
      'US-Tonne (short ton)': 907.185
    }
  },
  volume: {
    name: 'Volumen',
    units: {
      'Mikroliter (µL)': 0.000001,
      'Milliliter (mL)': 0.001,
      'Zentiliter (cL)': 0.01,
      'Deziliter (dL)': 0.1,
      'Liter (L)': 1,
      'Dekaliter (daL)': 10,
      'Hektoliter (hL)': 100,
      'Kiloliter (kL)': 1000,
      'Kubikzentimeter (cm³)': 0.001,
      'Kubikdezimeter (dm³)': 1,
      'Kubikmeter (m³)': 1000,
      'US-Flüssigunze (fl oz)': 0.0295735,
      'US-Pint (pt)': 0.473176,
      'US-Quart (qt)': 0.946353,
      'US-Gallone (gal)': 3.78541,
      'UK-Gallone (imp gal)': 4.54609
    }
  },
  area: {
    name: 'Fläche',
    units: {
      'Quadratmillimeter (mm²)': 0.000001,
      'Quadratzentimeter (cm²)': 0.0001,
      'Quadratdezimeter (dm²)': 0.01,
      'Quadratmeter (m²)': 1,
      'Ar (a)': 100,
      'Hektar (ha)': 10000,
      'Quadratkilometer (km²)': 1000000,
      'Quadratzoll (in²)': 0.00064516,
      'Quadratfuß (ft²)': 0.092903,
      'Quadratyard (yd²)': 0.836127,
      'Acre (ac)': 4046.86,
      'Quadratmeile (mi²)': 2589988.11
    }
  },
  density: {
    name: 'Dichte',
    units: {
      'Milligramm pro Kubikmeter (mg/m³)': 0.000001,
      'Gramm pro Kubikmeter (g/m³)': 0.001,
      'Kilogramm pro Kubikmeter (kg/m³)': 1,
      'Tonne pro Kubikmeter (t/m³)': 1000,
      'Gramm pro Kubikzentimeter (g/cm³)': 1000,
      'Gramm pro Liter (g/L)': 1,
      'Kilogramm pro Liter (kg/L)': 1000,
      'Gramm pro Milliliter (g/mL)': 1000,
      'Pfund pro Kubikfuß (lb/ft³)': 16.0185,
      'Pfund pro Gallone (US) (lb/gal(US))': 119.826,
      'Unze pro Kubikzoll (oz/in³)': 1729.994,
      'Pfund pro Kubikzoll (lb/in³)': 27679.9
    }
  },
  temperature: {
    name: 'Temperatur',
    units: {
      'Celsius (°C)': { base: 'celsius' },
      'Fahrenheit (°F)': { base: 'fahrenheit' },
      'Kelvin (K)': { base: 'kelvin' },
      'Rankine (°R)': { base: 'rankine' },
      'Réaumur (°Ré)': { base: 'reaumur' },
      'Delisle (°De)': { base: 'delisle' },
      'Newton (°N)': { base: 'newton' },
      'Rømer (°Rø)': { base: 'romer' },
      'Absolute Fahrenheit (°F abs)': { base: 'absolute_fahrenheit' },
      'Gas Mark (GM)': { base: 'gas_mark' }
    }
  },
  speed: {
    name: 'Geschwindigkeit',
    units: {
      'Millimeter pro Sekunde (mm/s)': 0.001,
      'Zentimeter pro Sekunde (cm/s)': 0.01,
      'Meter pro Sekunde (m/s)': 1,
      'Kilometer pro Sekunde (km/s)': 1000,
      'Kilometer pro Stunde (km/h)': 0.277778,
      'Meter pro Minute (m/min)': 0.016667,
      'Kilometer pro Minute (km/min)': 16.6667,
      'Meilen pro Stunde (mph)': 0.44704,
      'Fuß pro Sekunde (ft/s)': 0.3048,
      'Knoten (kn)': 0.514444,
      'Mach (M)': 343,
      'Lichtgeschwindigkeit (c)': 299792458
    }
  },
  wind_speed: {
    name: 'Windgeschwindigkeit',
    units: {
      'Meter pro Sekunde (m/s)': 1,
      'Kilometer pro Stunde (km/h)': 0.277778,
      'Knoten (kn)': 0.514444,
      'Meilen pro Stunde (mph)': 0.44704,
      'Fuß pro Sekunde (ft/s)': 0.3048,
      'Beaufort (Bft)': { base: 'beaufort' },
      'Knoten (kts)': 0.514444,
      'Zentimeter pro Sekunde (cm/s)': 0.01,
      'Millimeter pro Sekunde (mm/s)': 0.001,
      'Kilometer pro Minute (km/min)': 16.6667
    }
  },
  time: {
    name: 'Zeit',
    units: {
      'Nanosekunde (ns)': 0.000000001,
      'Mikrosekunde (µs)': 0.000001,
      'Millisekunde (ms)': 0.001,
      'Sekunde (s)': 1,
      'Minute (min)': 60,
      'Stunde (h)': 3600,
      'Tag (d)': 86400,
      'Woche (w)': 604800,
      'Monat (30 Tage) (mo)': 2592000,
      'Jahr (a)': 31536000,
      'Jahrzehnt (dec)': 315360000,
      'Jahrhundert (c)': 3153600000
    }
  },
  energy: {
    name: 'Energie',
    units: {
      'Joule (J)': 1,
      'Kilojoule (kJ)': 1000,
      'Megajoule (MJ)': 1000000,
      'Kalorie (cal)': 4.184,
      'Kilokalorie (kcal)': 4184,
      'Wattstunde (Wh)': 3600,
      'Kilowattstunde (kWh)': 3600000,
      'Elektronenvolt (eV)': 1.602176634e-19,
      'BTU (BTU)': 1055.06,
      'Therm (thm)': 105506000,
      'Fuß-Pfund (ft·lb)': 1.35582
    }
  },
  power: {
    name: 'Leistung',
    units: {
      'Watt (W)': 1,
      'Kilowatt (kW)': 1000,
      'Megawatt (MW)': 1000000,
      'PS (PS)': 735.5,
      'Pferdestärke (hp)': 745.7,
      'Dezibel-Milliwatt (dBm)': 0.001,
      'Kalorie pro Sekunde (cal/s)': 4.184,
      'BTU pro Stunde (BTU/h)': 0.29307,
      'Fuß-Pfund pro Sekunde (ft·lb/s)': 1.35582,
      'Fuß-Pfund pro Minute (ft·lb/min)': 0.022597,
      'Erg pro Sekunde (erg/s)': 0.0000001
    }
  },
  pressure: {
    name: 'Druck',
    units: {
      'Pascal (Pa)': 1,
      'Kilopascal (kPa)': 1000,
      'Megapascal (MPa)': 1000000,
      'Hektopascal (hPa)': 100,
      'Bar (bar)': 100000,
      'Millibar (mbar)': 100,
      'Millimeter Quecksilbersäule (mmHg)': 133.322,
      'Millimeter Wassersäule (mmH₂O)': 9.80665,
      'Pfund pro Quadratzoll (psi)': 6894.76,
      'Torr (Torr)': 133.322,
      'Atmosphäre (atm)': 101325,
      'Kilopond pro Quadratmeter (kp/m²)': 9.80665
    }
  },
  storage: {
    name: 'Digitaler Speicher',
    units: {
      'Bit (b)': 1,
      'Kilobit (kb)': 1024,
      'Megabit (Mb)': 1048576,
      'Gigabit (Gb)': 1073741824,
      'Terabit (Tb)': 1099511627776,
      'Byte (B)': 8,
      'Kilobyte (kB)': 8192,
      'Megabyte (MB)': 8388608,
      'Gigabyte (GB)': 8589934592,
      'Terabyte (TB)': 8796093022208,
      'Petabyte (PB)': 9007199254740992
    }
  },
  data_transfer: {
    name: 'Datenübertragung',
    units: {
      'Bit pro Sekunde (bps)': 1,
      'Kilobit pro Sekunde (kbps)': 1000,
      'Megabit pro Sekunde (Mbps)': 1000000,
      'Gigabit pro Sekunde (Gbps)': 1000000000,
      'Terabit pro Sekunde (Tbps)': 1000000000000,
      'Byte pro Sekunde (B/s)': 8,
      'Kilobyte pro Sekunde (kB/s)': 8000,
      'Megabyte pro Sekunde (MB/s)': 8000000,
      'Gigabyte pro Sekunde (GB/s)': 8000000000,
      'Terabyte pro Sekunde (TB/s)': 8000000000000
    }
  },
  angle: {
    name: 'Winkel',
    units: {
      'Bogensekunde (″)': 4.8481368e-6,
      'Bogenminute (′)': 0.000290888,
      'Grad (°)': 0.0174533,
      'Radiant (rad)': 1,
      'Gradiant (gon)': 0.0157080,
      'Vollwinkel (2π)': 6.28319,
      'Umdrehung (r)': 6.28319,
      'Quadrant (quad)': 1.5708,
      'Sextant (sxt)': 1.0472,
      'Oktant (oct)': 0.785398
    }
  },
  fuel: {
    name: 'Kraftstoffverbrauch',
    units: {
      'Liter pro 100 Kilometer (L/100km)': 1,
      'Kilometer pro Liter (km/L)': 100,
      'Meilen pro Gallone (US) (mpg US)': 235.215,
      'Meilen pro Gallone (UK) (mpg UK)': 282.481,
      'Gallone (US) pro 100 Meilen (gal/100mi US)': 42.5144,
      'Gallone (UK) pro 100 Meilen (gal/100mi UK)': 35.4006,
      'Meilen pro Liter (mi/L)': 100 * 0.621371,
      'Kilometer pro Gallone (US) (km/gal US)': 100 / 3.78541,
      'Kilometer pro Gallone (UK) (km/gal UK)': 100 / 4.54609,
      'Liter pro Meile (L/mi)': 100 / 1.60934
    }
  },
  acceleration: {
    name: 'Beschleunigung',
    units: {
      'Meter pro Sekunde² (m/s²)': 1,
      'Zentimeter pro Sekunde² (cm/s²)': 0.01,
      'Kilometer pro Sekunde² (km/s²)': 1000,
      'Kilometer pro Stunde pro Sekunde (km/h/s)': 0.277778,
      'Meilen pro Stunde pro Sekunde (mph/s)': 0.44704,
      'Fuß pro Sekunde² (ft/s²)': 0.3048,
      'Zoll pro Sekunde² (in/s²)': 0.0254,
      'Gal (Gal)': 0.01,
      'g (Erdbeschleunigung) (g)': 9.80665
    }
  },
  force: {
    name: 'Kraft',
    units: {
      'Newton (N)': 1,
      'Kilonewton (kN)': 1000,
      'Meganewton (MN)': 1000000,
      'Dyne (dyn)': 0.00001,
      'Kilopond (kp)': 9.80665,
      'Pfund-Kraft (lbf)': 4.44822,
      'Poundal (pdl)': 0.138255,
      'Unze-Kraft (ozf)': 0.278014,
      'Gramm-Kraft (gf)': 0.00980665
    }
  },
  radioactivity: {
    name: 'Radioaktivität',
    units: {
      'Becquerel (Bq)': 1,
      'Kilobecquerel (kBq)': 1000,
      'Megabecquerel (MBq)': 1000000,
      'Gigabecquerel (GBq)': 1000000000,
      'Terabecquerel (TBq)': 1000000000000,
      'Curie (Ci)': 37000000000,
      'Millicurie (mCi)': 37000000,
      'Mikrocurie (µCi)': 37000,
      'Nanocurie (nCi)': 37,
      'Rutherford (rd)': 1000000
    }
  },
  radiation_dose: {
    name: 'Strahlungsdosis',
    units: {
      'Gray (Gy)': 1,
      'Milligray (mGy)': 0.001,
      'Mikrogray (µGy)': 0.000001,
      'Rad (rad)': 0.01,
      'Sievert (Sv)': 1,
      'Millisievert (mSv)': 0.001,
      'Mikrosievert (µSv)': 0.000001,
      'Rem (rem)': 0.01
    }
  },
  si_prefixes: {
    name: 'SI-Präfixe',
    units: {
      'Quetta (Q)': 1e30,
      'Ronna (R)': 1e27,
      'Yotta (Y)': 1e24,
      'Zetta (Z)': 1e21,
      'Exa (E)': 1e18,
      'Peta (P)': 1e15,
      'Tera (T)': 1e12,
      'Giga (G)': 1e9,
      'Mega (M)': 1e6,
      'Kilo (k)': 1e3,
      'Hekto (h)': 1e2,
      'Deka (da)': 1e1,
      'Basis (1)': 1,
      'Dezi (d)': 1e-1,
      'Zenti (c)': 1e-2,
      'Milli (m)': 1e-3,
      'Mikro (µ)': 1e-6,
      'Nano (n)': 1e-9,
      'Piko (p)': 1e-12,
      'Femto (f)': 1e-15,
      'Atto (a)': 1e-18,
      'Zepto (z)': 1e-21,
      'Yokto (y)': 1e-24,
      'Ronto (r)': 1e-27,
      'Quekto (q)': 1e-30
    }
  },
  currency: {
    name: 'Währung',
    units: {}
  }
};